export function getInputUniforms() {
  return `uniform sampler2D input0;
uniform sampler2D input1;`;
}